@use "../../../../styles/Constants.scss" as Constants;

.footerActions {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding: Constants.$val-spacing-l;

	& > * + * {
		margin-left: Constants.$val-spacing-xs;
	}
}